module.exports = __webpack_public_path__ + "static/media/Explainer Video script 3_1603992324269.99a3b8d7.docx";